import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 400px',
    gridColumnGap: '2rem',
    marginTop: '0.5rem',

    '& > div:first-child': {
      margin: '0',
      padding: '0',
      paddingLeft: '3.5rem'
    }
  },

  list: {
    display: 'flex',
    flexDirection: 'column'
  },

  controls: {
    display: 'flex',
    alignItems: 'center'
  },

  buttonRoot: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& > button': {
      fontSize: theme.size.sm
    }
  },

  button: {
    width: 'fit-content',
    height: '31px',
    padding: '0 0.75rem'
  }
}))

export default useStyles
